import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccountSharedModule } from '../../account-shared/account-shared.module';
import { AppMenuModule } from './components/app-menu/app-menu.module';
import { CommonDiscoveryModule } from './components/discovery/common-discovery.module';
import { FooterModule } from './components/footer/footer.module';
import { CommonGridModule } from './components/grid/commongrid.module';
import { TanStackGridModule } from './components/data-table/tanstack-grid.module';
import { HeaderModule } from './components/header/header.module';
import { NavModule } from './components/navigation/navigation.module';
import { NotificationsModule } from './components/notifications/notifications.module';
import { PermissionsModule } from './components/permissions/permissions.module';
import { SpacesModule } from './components/spaces/spaces.module';
import { TouchpointsModule } from './components/touchpoints/touchpoints.module';
import { AudienceOnboardModule } from './modules/audience-onboard/audience-onboard.module';
import { TransactionsImportModule } from './modules/transactions-import/transactions-import.module';
import { CommonDeclarationsModule } from './modules/common-declarations/common-declarations.module';
import { EventHooksService } from './services/event-hooks.service';
import { IconsService } from './services/icons.service';
import { ImageUploaderService } from './services/image-uploader.service';
import { NgbTooltipConfig, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ReportBadgeModule } from 'account-hybrid/common/components/report-badge/report-badge.module';
import { ShowcaseStoriesModule } from 'account-hybrid/common/components/showcase-stories/showcase-stories.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ClickOutsideModule } from 'ng-click-outside';
import { MatIconModule } from '@angular/material/icon';
import { Modal2Component } from 'account-hybrid/common/components/modal2/modal2.component';
import { SmartFilterComponent } from 'account-hybrid/common/components/smart-filter/smart-filter.component';
import { SmartSortingComponent } from 'account-hybrid/common/components/smart-sorting/smart-sorting.component';
import { DropdownMenuComponent } from 'account-hybrid/common/components/dropdown-menu/dropdown-menu.component';
import {
    OauthResultViewComponent
} from 'account-hybrid/common/components/oauth-result-view/oauth-result-view.component';
// WS4 inc 5 (Track A): native Angular redirect components replacing the AngularJS global
// UIRouter redirect states (registered in GLOBAL_STATES, used as `component:` states — the
// OauthResultViewComponent precedent).
import {
    CurationAllRedirectComponent,
    FeedbackAllRedirectComponent,
    RecommendationRedirectComponent,
    InvitationRedirectComponent,
    TimelineRedirectComponent,
    CurateGuestRedirectComponent,
    HomeRedirectComponent,
} from './components/global-redirect/global-redirect.components';

@NgModule({
    imports: [
        CommonModule,
        AccountSharedModule,
        CommonDeclarationsModule,
        AppMenuModule,
        HeaderModule,
        NavModule,
        NotificationsModule,
        SpacesModule,
        TouchpointsModule.forRoot(),
        PermissionsModule,
        CommonDiscoveryModule,
        AudienceOnboardModule,
        TransactionsImportModule,
        CommonGridModule,
        TanStackGridModule,
        NgbTooltipModule,
        ReportBadgeModule,
        ShowcaseStoriesModule,
        ReactiveFormsModule,
        ClickOutsideModule,
        MatIconModule,
    ],
    providers: [EventHooksService, IconsService, ImageUploaderService],
    exports: [
        CommonModule,
        AccountSharedModule,
        AppMenuModule,
        HeaderModule,
        FooterModule,
        NavModule,
        NotificationsModule,
        SpacesModule,
        TouchpointsModule,
        PermissionsModule,
        CommonDiscoveryModule,
        CommonDeclarationsModule,
        CommonGridModule,
        TanStackGridModule,
        ReportBadgeModule,
        ShowcaseStoriesModule,
        Modal2Component,
        SmartFilterComponent,
        SmartSortingComponent,
        DropdownMenuComponent,
        OauthResultViewComponent,
        CurationAllRedirectComponent,
        FeedbackAllRedirectComponent,
        RecommendationRedirectComponent,
        InvitationRedirectComponent,
        TimelineRedirectComponent,
        CurateGuestRedirectComponent,
        HomeRedirectComponent,
    ],
    declarations: [
        Modal2Component,
        SmartFilterComponent,
        SmartSortingComponent,
        DropdownMenuComponent,
        OauthResultViewComponent,
        CurationAllRedirectComponent,
        FeedbackAllRedirectComponent,
        RecommendationRedirectComponent,
        InvitationRedirectComponent,
        TimelineRedirectComponent,
        CurateGuestRedirectComponent,
        HomeRedirectComponent,
    ],
})
export class AccountCommonModule {
    constructor(config: NgbTooltipConfig) {
        config.triggers = 'hover focus';
        config.autoClose = 'outside';
        config.placement = 'top';
        config.tooltipClass = 'tooltip-small';
    }
}
